/**
 * Replaces placeholders in a template string with corresponding values.
 *
 * Placeholders in the template must be in the form `{0}`, `{1}`, `{2}`, etc.
 * Each number corresponds to the index of a value in the `values` array.
 * If a placeholder doesn't have a matching value, it remains unchanged.
 *
 * @param {string} template - The string containing numbered placeholders like `{0}`, `{1}`, etc.
 * @param {...string} values - A list of values to replace the placeholders with.
 * @returns {string} A formatted string with the placeholders replaced by corresponding values.
 *
 * @example
 * formatTemplateString("Hello, {0} {1}!", "Jane", "Doe");
 * // Returns: "Hello, Jane Doe!"
 *
 * @example
 * formatTemplateString("This is {0}, not {1}.", "fine");
 * // Returns: "This is fine, not {1}."
 */
const formatTemplateString = (
  template: string,
  ...values: string[]
): string => {
  return template.replace(/{(\d+)}/g, (match, number) =>
    typeof values[number] !== "undefined" ? values[number] : match,
  );
};

export default formatTemplateString;
